<template>
    <div>
        <template v-if="dataLoaded && survey">
            <b-container v-if="dataLoaded" fluid>
                <b-row>
                    <b-col sm="12">
                        <h3>Respuestas a Encuesta/Quiz:</h3>
                        <h2 class="mb-4 text-center"><strong>{{ survey.name }}</strong></h2>
                        <h4>
                            <b-button
                                variant="info"
                                class="mx-2"
                                :to="{ name: 'site-teacher-surveys-detail' }"
                            >
                                <b-icon-arrow-bar-left /> Atrás
                            </b-button>
                            [{{ survey.student.identityCard }}] {{ survey.student.fullname }}
                        </h4>
                        <hr />
                    </b-col>
                </b-row>
            <!-- Survey details -->
                <b-row>
                    <b-col sm="12">
                        <div
                            class="mb-2"
                            style="min-height: 30px; font-size: 1rem;"
                        >
                            <span v-if="survey.isEvaluated">
                                Resultado Obtenido:
                                <strong>{{ survey.studentSurvey.totalValueDisplay }} %</strong>
                            </span>
                        </div>
                    </b-col>
                </b-row>
                <SurveyQuestionAnswers
                    v-for="(question, index) in survey.questions"
                    :key="`question-${question.id}`"
                    :question="question"
                    :number="index + 1"
                />
            </b-container>
        </template>
    </div>
</template>

<script>
import SurveyQuestionAnswers from './components/SurveyQuestionAnswers'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'TeachingStaffSurveyAnswers',
    components: {
        SurveyQuestionAnswers
    },
    data () {
        return {
            dataLoaded: false
        }
    },
    computed: {
        ...mapState({
            activeSite: 'activeSite',
            survey: 'selectedSurveyObject'
        }),
        ...mapGetters([
            'isUserStudenTeacherOrBetter'
        ])
    },
    watch: {
        async '$route' (to, from) {
            // Only reload site from backend API if the url surveyId parameter changed
            if (to.params.surveyId && from.params.surveyId && to.params.studentSurveyId && from.params.studentSurveyId) {
                if ((to.params.surveyId !== from.params.surveyId) || (to.params.studentSurveyId !== from.params.studentSurveyId)) {
                    await this.loadStudentSurveyAnswers()
                }
            }
        }
    },
    methods: {
        ...mapActions([
            'readStudentSurveyAnswersDetails'
        ]),
        async loadStudentSurveyAnswers () {
            let loader = this.$loading.show()
            this.dataLoaded = false
            try {
                if (this.isUserStudenTeacherOrBetter) {
                    var payload = { courseSiteId: this.activeSite.id, surveyId: this.$route.params.surveyId, studentSurveyId: this.$route.params.studentSurveyId }
                    await this.readStudentSurveyAnswersDetails(payload)
                    if (this.survey.studentSurvey.completedAt === null) {
                        this.$router.replace({ name: 'site-teacher-surveys-detail' })
                    }
                }
                this.dataLoaded = true
            } catch (err) {
                console.log(err)
                if (err.response && (err.response.status === 404 || err.response.status === 403)) {
                    // If the survey does not exists or the user is not part of the teaching staff
                    // Redirect the user to the site general info section
                    this.$router.replace({ name: 'site-general-info' })
                } else {
                    this.$root.unknownErrorToast()
                }
                this.dataLoaded = false
            } finally {
                loader.hide()
            }
        }
    },
    async created () {
        this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
        await this.loadStudentSurveyAnswers()
    }
}
</script>
